// src/components/Carousel/context.ts
import { createContext } from "react";
var CarouselContext = createContext({
  onPrevClick: () => {},
  onNextClick: () => {}
});
export { CarouselContext };